import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  deleteDoc,
  query,
  where
} from 'firebase/firestore';
import { db } from '../firebase/config';

const ROLES_COLLECTION = 'roles';

// Crear rol
export const createRole = async (roleData) => {
  try {
    const roleRef = doc(collection(db, ROLES_COLLECTION));
    await setDoc(roleRef, {
      ...roleData,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    });
    return { id: roleRef.id, ...roleData };
  } catch (error) {
    console.error('Error creando rol:', error);
    throw error;
  }
};

// Obtener rol por ID
export const getRoleById = async (roleId) => {
  try {
    const roleDoc = await getDoc(doc(db, ROLES_COLLECTION, roleId));
    if (roleDoc.exists()) {
      return { id: roleDoc.id, ...roleDoc.data() };
    }
    return null;
  } catch (error) {
    console.error('Error obteniendo rol:', error);
    throw error;
  }
};

// Obtener todos los roles
export const getAllRoles = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, ROLES_COLLECTION));
    const roles = [];
    querySnapshot.forEach((doc) => {
      roles.push({ id: doc.id, ...doc.data() });
    });
    return roles;
  } catch (error) {
    console.error('Error obteniendo roles:', error);
    throw error;
  }
};

// Actualizar rol
export const updateRole = async (roleId, updates) => {
  try {
    await updateDoc(doc(db, ROLES_COLLECTION, roleId), {
      ...updates,
      updatedAt: new Date().toISOString()
    });
  } catch (error) {
    console.error('Error actualizando rol:', error);
    throw error;
  }
};

// Eliminar rol
export const deleteRole = async (roleId) => {
  try {
    await deleteDoc(doc(db, ROLES_COLLECTION, roleId));
  } catch (error) {
    console.error('Error eliminando rol:', error);
    throw error;
  }
};

// Inicializar rol de super administrador si no existe
export const initializeSuperAdminRole = async () => {
  try {
    const roles = await getAllRoles();
    const superAdminRole = roles.find(role => role.isSuperAdmin);

    if (!superAdminRole) {
      const roleRef = doc(collection(db, ROLES_COLLECTION));
      await setDoc(roleRef, {
        name: 'Super Administrador',
        isSuperAdmin: true,
        permissions: {
          modules: ['*'] // Acceso a todos los módulos
        },
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      });
      return roleRef.id;
    }
    return superAdminRole.id;
  } catch (error) {
    console.error('Error inicializando rol super admin:', error);
    throw error;
  }
};
